import classNames from 'classnames';

const MediaSave = ({
	className,
	value,
	fit = 'cover',
	aspectRatio = 'auto',
	style,
	...props
}) => {
	const { type = 'image', imageRef, externalVideoRef } = value || {};
	const aspectRatioStyle =
		aspectRatio === 'inherit'
			? {}
			: { '--media-aspect-ratio': aspectRatio };

	return (
		<div
			className={classNames('ona-media', `ona-media--${fit}`, className)}
			style={{ ...aspectRatioStyle, ...style }}
			{...props}
		>
			{type === 'image' && imageRef && imageRef.previewUrl && (
				<img
					className="ona-media__media ona-media__media--image"
					src={imageRef.previewUrl}
					alt=""
				/>
			)}
			{type === 'video' && externalVideoRef && externalVideoRef.url && (
				<div className="ona-media__video-wrapper">
					{/* eslint-disable-next-line jsx-a11y/media-has-caption */}
					<video
						className="ona-media__media ona-media__media--video"
						src={externalVideoRef.url}
						autoPlay
						muted
						loop
						playsInline
					/>
				</div>
			)}
		</div>
	);
};

export default MediaSave;
